import _parseInt from 'lodash/parseInt';
import _toFinite from 'lodash/toFinite';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_ON_DEMAND_LIST,
  CPM_CATEGORIZE_CARPARK_ON_DEMAND,
  CPM_DELETE_CARPARK_ON_DEMAND,
  CPM_CREATE_ON_DEMAND_ACCESS,
  CPM_TERMINATE_ON_DEMAND_ACCESS,
  CPM_UPDATE_ON_DEMAND_ACCESS,
  CPM_REFUND_ON_DEMAND_ACCESS,
  CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeOperation } from '../../../models/cpm/synchronization';
import { deserialize } from '../../../models/cpm/onDemand';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkOnDemand;
const cpmCarparkOnDemand = (state = initialSettings, action) => {
  let key;
  let mutationResult;
  let parkingId;
  // let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          list: { ...initialSettings.list },
          categorize: { ...initialSettings.categorize },
          add: { ...initialSettings.add },
          delete: { ...initialSettings.delete },
          terminate: { ...initialSettings.terminate },
          update: { ...initialSettings.update },
        };
      }
      switch (action.target) {
        case 'addCarparkOnDemand':
          key = 'add';
          break;
        case 'categorizeCarparkOnDemand':
          key = 'categorize';
          break;
        case 'terminateCarparkOnDemand':
          key = 'terminate';
          break;
        case 'updateCarparkOnDemand':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // CPM_GET_CARPARK_ON_DEMAND_LIST
    case CPM_GET_CARPARK_ON_DEMAND_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_ON_DEMAND_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_ON_DEMAND_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listOnDemandAccesses.entries),
            pageNumber: _parseInt(action.data.listOnDemandAccesses.pageNumber),
            pageSize: _parseInt(action.data.listOnDemandAccesses.pageSize),
            totalEntries: _parseInt(action.data.listOnDemandAccesses.totalEntries),
            totalPages: _parseInt(action.data.listOnDemandAccesses.totalPages),
          },
        },
      };
    // CPM_CATEGORIZE_CARPARK_ON_DEMAND
    case CPM_CATEGORIZE_CARPARK_ON_DEMAND:
      return {
        ...state,
        categorize: {
          ...state.categorize,
          done: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_CATEGORIZE_CARPARK_ON_DEMAND}_ERROR`:
      return {
        ...state,
        categorize: {
          ...state.categorize,
          error: action.error,
        },
      };
    case `${CPM_CATEGORIZE_CARPARK_ON_DEMAND}_SUCCESS`:
      mutationResult = action.data.categorizeOnDemandAccess;
      parkingId = action.parkingId;
      return {
        ...state,
        categorize: {
          ...state.categorize,
          done: true,
          result: {
            ...mutationResult,
            id: _toFinite(parkingId),
            operation: deserializeOperation(mutationResult),
          },
        },
      };
    // CPM_DELETE_CARPARK_ON_DEMAND
    case CPM_DELETE_CARPARK_ON_DEMAND:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DELETE_CARPARK_ON_DEMAND}_ERROR`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case `${CPM_DELETE_CARPARK_ON_DEMAND}_SUCCESS`:
      mutationResult = action.data.deleteOnDemandAccess;
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // CPM_REFUND_ON_DEMAND_ACCESS
    case CPM_REFUND_ON_DEMAND_ACCESS:
      return {
        ...state,
        refund: {
          ...state.refund,
          error: null,
          loading: true,
          refunded: false,
        },
      };
    case `${CPM_REFUND_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        refund: {
          ...state.refund,
          refunded: false,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_REFUND_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        refund: {
          ...state.refund,
          refunded: true,
          error: null,
          loading: false,
        },
      };
    // CPM_CREATE_ON_DEMAND_ACCESS
    case CPM_CREATE_ON_DEMAND_ACCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case `${CPM_CREATE_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_CREATE_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // CPM_TERMINATE_ON_DEMAND_ACCESS
    case CPM_TERMINATE_ON_DEMAND_ACCESS:
      return {
        ...state,
        terminate: {
          ...state.terminate,
          terminated: false,
          error: null,
        },
      };
    case `${CPM_TERMINATE_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        terminate: {
          ...state.terminate,
          error: action.error,
        },
      };
    case `${CPM_TERMINATE_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        terminate: {
          ...state.terminate,
          terminated: true,
        },
      };
    // CPM_UPDATE_ON_DEMAND_ACCESS
    case CPM_UPDATE_ON_DEMAND_ACCESS:
    case CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case `${CPM_UPDATE_ON_DEMAND_ACCESS}_ERROR`:
    case `${CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE}_SUCCESS`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkOnDemand;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkOnDemand.js